import {Injectable} from '@angular/core';

interface User {
    id: string;
    firstname: string;
    lastname: string;
    email: string;
    phone: string;
    rights?: string[];
}

@Injectable({
    providedIn: 'root'
})
export class AccessService {

    private _token: string = '';
    private _user: User = null;

    get token() {
        return this._token;
    }

    set token(token: string) {
        this._token = token;
    }

    get user() {
        return this._user;
    }

    set user(user: any) {
        this._user = user;
    }

    hasRight(right: string): boolean {
        return this._user.rights.includes(right);
    }

    isEditor(task): boolean {
        return this._user.id == task.id_editor;
    }
}
